import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios';
import { API_URL } from '@constants';
import { getTokenFromKeycloak } from '@services';
import {comLoading} from '@stores';
import type { CabecalhosRequisicao, ClienteHttp, OpcoesResposta, ParametrosRequisicao } from '../types';

export const instance = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

instance.interceptors.request.use(async config => {
    const token = await getTokenFromKeycloak();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
}, error => {
    return Promise.reject(error);
});


export function useRequest(): ClienteHttp {
    function get<T>(url: string, params?: ParametrosRequisicao, headers?: CabecalhosRequisicao, opcoes?: OpcoesResposta): Promise<AxiosResponse<T>> {
        return comLoading(instance.get<T>(url, { params, headers, ...opcoes }));
    }

    function post<T, D = unknown>(url: string, body?: D, headers?: CabecalhosRequisicao, opcoes?: OpcoesResposta): Promise<AxiosResponse<T>> {
        return comLoading(instance.post<T>(url, body, { headers, ...opcoes }));
    }

    function put<T, D = unknown>(url: string, body?: D, headers?: CabecalhosRequisicao, opcoes?: OpcoesResposta): Promise<AxiosResponse<T>> {
        return comLoading(instance.put<T>(url, body, { headers, ...opcoes }));
    }

    function delet<T, D = unknown>(url: string, body?: D, headers?: CabecalhosRequisicao, opcoes?: OpcoesResposta): Promise<AxiosResponse<T>> {
        const config: AxiosRequestConfig<D> = { data: body, headers, ...opcoes };
        return comLoading(instance.delete<T>(url, config));
    }

    return {
        get,
        post,
        put,
        delet,
    };
}
